import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { CheckCircle2, Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "checking" });
  const nav = useNavigate();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const r = await publicApi.get(`/billing/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid" || r.data.status === "completed") {
          setState({ status: "success" });
          await refresh();
          return;
        }
      } catch { /* keep polling */ }
      if (tries < 20) setTimeout(poll, 2000);
      else setState({ status: "timeout" });
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="billing-success-page">
      <div className="pb-card p-8 max-w-lg w-full text-center">
        {state.status === "checking" && (<>
          <div className="pb-heading text-2xl font-black">Even geduld…</div>
          <div className="text-slate-600 font-semibold mt-2">We bevestigen je proefperiode bij Stripe.</div>
          <div className="mt-4 w-8 h-8 mx-auto border-4 border-orange-600 border-t-transparent rounded-full animate-spin"/>
        </>)}
        {state.status === "success" && (<>
          <div className="w-16 h-16 rounded-full bg-orange-600 text-white flex items-center justify-center mx-auto"><CheckCircle2 size={32}/></div>
          <div className="pb-heading text-3xl font-black mt-3">Klaar!</div>
          <div className="text-slate-700 font-semibold mt-2">Je proefperiode loopt. Je hebt 7 dagen om alles rustig te bekijken — geen betaling gedaan.</div>
          <button onClick={() => nav("/planbord")} className="pb-btn-primary mt-6 w-full flex items-center justify-center gap-2 !min-h-[48px]" data-testid="btn-continue">
            <Zap size={16}/> Naar het planbord
          </button>
        </>)}
        {state.status === "timeout" && (<>
          <div className="pb-heading text-2xl font-black">Duurt langer dan verwacht</div>
          <div className="text-slate-600 font-semibold mt-2">De bevestiging komt binnenkort door. Je kunt gewoon inloggen.</div>
          <Link to="/billing" className="pb-btn-primary mt-6 w-full flex items-center justify-center">Naar Facturatie</Link>
        </>)}
        {state.status === "error" && (<>
          <div className="pb-heading text-2xl font-black">Sessie ontbreekt</div>
          <Link to="/" className="pb-btn-outline mt-4 inline-block">Terug naar de website</Link>
        </>)}
      </div>
    </div>
  );
}
